const images = require.context('./', false, /\.(png|jpe?g)$/);
